import { APP_INITIALIZER, PLATFORM_ID, Provider } from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';

export function provideGoogleMaps(apiKey: string): Provider {
    return {
        provide: APP_INITIALIZER,
        useFactory: (platformId: object, document: Document) => initializeApp(platformId, document, apiKey),
        deps: [PLATFORM_ID, DOCUMENT],
        multi: true,
    };
}

function initializeApp(platformId: object, document: Document, apiKey: string): () => void {
    return (): void => {
        if (!apiKey) {
            console.warn('Google Maps API Key not provided. Address autocomplete will not work.');
            return;
        }

        if (isPlatformBrowser(platformId)) {
            // Official Google Maps JS API bootstrap snippet (Adapted/Typed)
            ((g: Record<string, string>): void => {
                let h: Promise<unknown> | undefined;
                const p = 'The Google Maps JavaScript API';
                const c = 'google';
                const l = 'importLibrary';
                const q = '__ib__';
                const m = document;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                let b = window as any;
                b = b[c] || (b[c] = {});

                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const d = b.maps || (b.maps = {} as any);
                const r = new Set<string>();
                const e = new URLSearchParams();
                const u = (): Promise<unknown> =>
                    h ||
                    (h = new Promise((f, n) => {
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        const a = m.createElement('script') as any;
                        e.set('libraries', [...r] + '');
                        for (const k in g) {
                            e.set(
                                k.replace(/[A-Z]/g, (t) => '_' + t[0].toLowerCase()),
                                g[k],
                            );
                        }
                        e.set('callback', c + '.maps.' + q);
                        a.src = `https://maps.googleapis.com/maps/api/js?` + e.toString();
                        d[q] = f;
                        a.onerror = (): void => {
                            n(Error(p + ' could not load.'));
                            h = undefined;
                        };
                        a.nonce = (m.querySelector('script[nonce]') as HTMLScriptElement)?.nonce || '';
                        m.head.append(a);
                    }));

                d[l]
                    ? console.warn(p + ' only loads once. Ignoring:', g)
                    : (d[l] = (f: string, ...n: unknown[]): Promise<unknown> => r.add(f) && u().then(() => d[l](f, ...n)));
            })({
                key: apiKey,
                v: 'weekly',
            });
        }
    };
}
